// extracted by mini-css-extract-plugin
export default {"wrapper":"_5b3de7ae","content":"_9ac35bf4","seeMore":"_2166765b","chairLamp":"_ac8973bc","browseMoreButton":"_cbaccd20"};